<template>
  <v-data-table
    :headers="tableHeaders"
    :items="nfeItems"
    :expanded.sync="expandedItems"
    :single-expand="false"
    item-key="item.name"
    show-expand
    :items-per-page="-1"
    class="elevation-1"
    :hide-default-footer="true"
    mobile-breakpoint="960"
  >
    <template v-slot:item.unitPrice="{ item }">
      <span>
        {{ item.unitPrice | formatCurrency_10d }}
      </span>
    </template>
    <template v-slot:item.quantity="{ item }">
      <span>
        {{ item.quantity | formatNumber }}
      </span>
    </template>
    <template v-slot:item.totalPrice="{ item }">
      <span>
        {{ item.totalPrice | formatCurrency }}
      </span>
    </template>
    <template v-slot:item.totalPriceWithExtraValues="{ item }">
      <span>
        {{ item.totalPriceWithExtraValues | formatCurrency }}
      </span>
    </template>
    <template v-slot:item.action="{ item }">
      <TaxationRuleEdit
        :entry="item.taxationRule"
        :readOnly="true"
        readIcon="mdi-cog-transfer-outline"
        modelNameSingular="Regra de Tributação"
      />
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="py-4">
        <NfeItemForm
          :entry="item"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import NfeItemForm from "./form.vue";
import TaxationRuleEdit from "@models/fiscal_documents/outbounds/taxation_groups/taxation_rules/edit.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      tableHeaders: [
        { text: "Produto", align: "left", sortable: true, value: "description" },
        { text: "R$", align: "left", sortable: true, value: "unitPrice" },
        { text: "Qtd.", align: "left", sortable: true, value: "quantity" },
        { text: "Und.", align: "left", sortable: true, value: "packagingUnitName" },
        { text: "R$ Subtotal", align: "left", sortable: true, value: "price" },
        { text: "R$ Total Rateado", align: "left", sortable: true, value: "totalPriceWithExtraValues" },        
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
      ],
      expandedItems: []
    };
  },
  components: {
    NfeItemForm: NfeItemForm,
    TaxationRuleEdit: TaxationRuleEdit
  },
  props: {
    nfeItems: {
      type: Array,
      default: []
    },
    printing: {
      type: Boolean,
      default: false
    }
  },
  watch : {
    printing: function() {
      // console.log("Printing changed - NFE items");
      if (this.printing) {
        this.expandedItems = [];
        for (let item in this.nfeItems) {
          this.expandedItems.push(this.nfeItems[item]);
        }
      } else {
        this.expandedItems = [];
      }
    }
  },
  created() {
    // console.log(this.nfeItems);
  },
  methods: {

  }
};
</script>

<style scoped></style>
